export class EndoMultiToothExamSurfaceDataModel {
  MTEToothSurfaceID: string;
  MTEToothID: string;
  SurfaceOrder: number;
  ToothSurfaceId: string;
  enumProbingDepthID: string;
}
